import { Http } from "@/plugins/http";

export class ParamsService {
  static _params = [];

  /**
   * @return Promise<MedParam[]>
   */
  static async getAll() {
    if (ParamsService._params.length) {
      return ParamsService._params;
    }

    const items = await Http.get(`v1/params`, { params: { lang: "ru" } }).then(response => response.data?.data ?? []);
    ParamsService._params = items;

    return items;
  }

  /**
   * @property {number} paramId
   * @return Promise<MedParamMeasure[]>
   */
  static getMeasure(paramId) {
    return Http.get(`v1/params/${paramId}`, { params: { lang: "ru" } }).then(response => response.data.data);
  }
}
